<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        {{getDatasetDisplayType(dataSetType)}} Extraction Accuracy
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#"><i class="fa fa-dashboard"></i> Home</a>
        </li>
        <li class="active">{{getDatasetDisplayType(dataSetType)}} Evaluate</li>
      </ol>
    </section>
    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-xs-12">
          <div class="box">
            <div class="file-display-div">
              <strong>File name: </strong>{{fileName}}
              <br/>
              <strong>Gender count: </strong> Women - {{womenCount}}, Men - {{menCount}}
            </div>
            <div >
              <div class="col-xs-12 col-md-12 col-lg-12 audit-tree-select">
                  <vue-good-table
                    styleClass="vgt-table good-table condensed striped"
                    :columns="columns"
                    :rows="evaluatedData"
                    :pagination-enabled="false"
                  >
                    <div slot="emptystate"><nv-empty-state icon="fa-check-square-o" title="Nothing to evaluate" hint="There are no records in this dataset yet." /></div>
                      <template slot="loadingContent">
                        <!-- Empty loading screen to disable default loading -->
                      </template>
                      <template slot="table-row" slot-scope="props">
                        <slot :props="props" />
                        <span v-if="props.column.field === 'gender'" class="bold-text">{{props.formattedRow[props.column.field]}}</span>
                        <span v-else>{{parseFloat(props.formattedRow[props.column.field].toFixed(3))}}%</span>
                      </template>
                  </vue-good-table>
              </div>

            </div>
                <div class="audit-save-btn">
                  <router-link :to="`/auditing/${dataSetType}`">
                    <button type="button" class="btn btn-primary" style="margin: 30px 0px;">Go back</button> 
                  </router-link>
              </div>
          </div>
        </div>
      </div>
      <!-- /.row -->
    </section>
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>   
  </div>
</template>

<script>
import api from '../../../utils/api'
import { getDatasetDisplayType } from './helpers'

export default {
  name: 'auditing',
  components: {
  },
  data () {
    return {
      dataSetId: '',
      evaluatedData: [],
      fileName: '',
      dataSetType: '',
      getDatasetDisplayType: getDatasetDisplayType,
      womenCount: 0,
      menCount: 0,
      loading: true,
      columns: [
        {
          label: '',
          field: 'gender',
          width: '40%',
          sortable: false
        },
        {
          label: 'Precision',
          field: 'precision',
          width: '30%',
          sortable: false
        },
        {
          label: 'Recall',
          field: 'recall',
          width: '30%',
          sortable: false
        }
      ]
    }
  },
  mounted () {
    if (this.$route.path) {
      this.dataSetId = this.$route.path.split('/').pop()
    }
    this.loading = false
    this.getEvaluationResult()
  },
  methods: {
    getEvaluationResult () {
      this.loading = true
      api.buildRequest(`/audit/evaluate/${this.dataSetId}`, 'GET')
          .then(response => {
            this.loading = false
            if (response.status === 200) {
              this.evaluatedData = Object.keys(response.data.payload.evaluation).map((key) => {
                let gender = key.charAt(0).toUpperCase() + key.slice(1)
                return {
                  gender: gender,
                  ...response.data.payload.evaluation[key]
                }
              })
              this.womenCount = response.data.payload.genderCounts.womenCount
              this.menCount = response.data.payload.genderCounts.menCount
              this.fileName = response.data.payload.fileName
              this.dataSetType = response.data.payload.dataSetType
            } else {
              this.$swal({
                type: 'error',
                text: 'An error occurred'
              })
            }
          }).catch(({ response }) => {
            this.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
    }
  }
}
</script>

<style scoped>
.value {
  font-weight: bold;
}
input[type="file"] {
  display: none;
}
.box-body {
  min-height: calc(100vh - 171px);
}
.form-loader img {
  width: 30px;
  height: 30px;
}
.btn-import-dataset {
  margin-bottom: 15px;
  margin-right: 15px;
}
.file-display-div {
  font-size: 20px;
  margin-top: 10px;
  margin-left: 25px;
  margin-bottom: 10px;
}
.audit-save-btn {
  text-align: right;
  margin-right: 15px;
}
</style>
<style>
.audit-tree-select .vue-treeselect__multi-value {
  margin-left: 5px;
}
.bold-text {
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// evaluate.vue?05641aeb